/**
 * feat-235 — a Track's square: uploaded art if there is any, else the derived
 * monogram (see `trackArt.ts` for why there is no mascot picker behind it).
 *
 * Precedence is deliberately SHORTER than the Lesson swatch's
 * (`image_s3_key → mascot_key → emoji → 🍔`), and the spec says so in its own
 * section ("`learn_track` has NO `emoji` column — deliberately"): the chain does
 * not transfer, because a track with no art would resolve to NOTHING at the end
 * of it. `mascot_key` also has no control and no renderer this slice, so reading
 * it here would draw a value nothing in this product can set.
 *
 * So: `image_s3_key → monogram`, and THE MONOGRAM IS TERMINAL. Do not add an
 * emoji step, and do not ask backend for the column to hang one on.
 */

import React from 'react';
import { trackImagePublicUrl } from '../../../../services/quizContentAdminService';
import { trackMonogram } from './trackArt';

export const TrackSwatch: React.FC<{
  title: string;
  imageKey: string | null;
  /** Box classes — size, radius, border. */
  className?: string;
  /** Monogram type classes (size/weight) for this call site. */
  monogramClassName?: string;
  testId?: string;
}> = ({ title, imageKey, className = '', monogramClassName = '', testId }) => {
  const url = trackImagePublicUrl(imageKey);
  if (url) {
    return (
      <img
        src={url}
        alt=""
        data-testid={testId}
        className={`object-cover overflow-hidden shrink-0 ${className}`}
      />
    );
  }
  return (
    <span
      data-testid={testId}
      aria-hidden
      className={`grid place-items-center shrink-0 overflow-hidden bg-cream-dark text-preview font-bold ${className} ${monogramClassName}`}
    >
      {trackMonogram(title)}
    </span>
  );
};

export default TrackSwatch;
